<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <material-card
      v-if="dialog"
      :offset="10"
      :full-width="true"
      color="green"
      title="Employee Incidents"
      text="Remove Employee Incidents"
      class="mb-0"
    >
      <v-card-text> Are you sure you want to remove this incident? </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Remove
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        incident: {},
      }
    },
    methods: {
      toggleDialog (incident) {
        this.incident = { ...incident }

        this.dialog = true
      },
      submitForm () {
        this.progressing = true

        this.$api.incidents().delete(this.employeeUid, this.incident.id)
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              this.$emit('deleted')
              this.$snack({ message: response.data.status })
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
            this.dialog = false
          })
      },
    },
  }
</script>
